/* External Imports */
import { Box, Text, useBreakpointValue } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"
const AboutDeviSlide11 = () => {
  return (
    <Box bgColor="#000" className={styles.section11Bg} overflow="hidden">
      <Box
        maxW="1300px"
        width="100%"
        px={{ base: 4, md: 7 }}
        py={{ base: 6, md: '1rem' }}
        mx="auto"
        minH="100vh"
      >
        <Box
          w="100%"
          pos={{ base: 'static', md: 'relative' }}
          top={{ base: '0rem', md: '6rem', lg: '9rem' }}
          right="0rem"
          display="flex"
          justifyContent={{ base: 'center', lg: 'flex-start' }}
          pl={{ base: '1rem', lg: '0rem', xl: '12rem' }}
        >
          <Text
            pos={{ base: 'static', md: 'relative' }}
            w={{ base: '19rem', sm: '21rem', lg: '28rem' }}
            color="#fff"
            fontSize={{ base: '20px', lg: '30px' }}
            textAlign="center"
            pb={{ base: '2rem' }}
          >
            Not mere idols,
            <span style={{ color: '#D09700' }}>
              {' '}
              these energy forms, including Devi, are a living reality for those
              who know how to access them.
            </span>
          </Text>
        </Box>
        <LazyLoadImageComponent
          src={useBreakpointValue({
            base: `${config.imgPath}/d/46272/1684475434-lb_sadhguru_img6.jpg`,
            lg: `${config.imgPath}/d/46272/1684475434-lb_sadhguru_img6.jpg`,
          })}
          alt="sadhguru_img3"
          width={useBreakpointValue({
            base: '27rem',
            md: '30rem',
            lg: '32rem',
            xl: '36rem',
          })}
          pos="relative"
          top={{ base: '2rem', md: '7rem', lg: '-4rem', xl: '0rem' }}
          left={{ base: '10px', md: '19rem', lg: '30rem', xl: '47rem' }}
          pr={{ base: '7rem', md: '4rem' }}
          zIndex="3"
        />

        <LazyLoadImageComponent
          src={useBreakpointValue({
            base: `${config.imgPath}/d/46272/1684475429-lb_sadhguru_img7.jpg`,
            lg: `${config.imgPath}/d/46272/1684475429-lb_sadhguru_img7.jpg`,
          })}
          alt=""
          width={useBreakpointValue({
            base: '27rem',
            md: '33rem',
            lg: '33rem',
            xl: '38rem',
          })}
          position="relative"
          pl={{ base: '6rem', md: '4rem' }}
          top={{ base: '0px', md: '3rem', lg: '-5rem', xl: '9rem' }}
          left={{ base: '0rem', md: '5rem', lg: '-2rem', xl: '-29rem' }}
          zIndex="2"
        />

        <LazyLoadImageComponent
          src={useBreakpointValue({
            base: `${config.imgPath}/d/46272/1684475423-lb_sadhguru_img8.jpg`,
            lg: `${config.imgPath}/d/46272/1684475423-lb_sadhguru_img8.jpg`,
          })}
          alt=""
          width={useBreakpointValue({
            base: '27rem',
            md: '33rem',
            lg: '34rem',
            xl: '37rem',
          })}
          position="relative"
          top={{ base: '-1rem', md: '0rem', lg: '-9rem', xl: '-7rem' }}
          left={{ base: '0rem', md: '14rem', lg: '17rem', xl: '32rem' }}
          pr={{ base: '6rem', md: '4rem' }}
          zIndex="1"
        />
      </Box>
    </Box>
  );
};
export default AboutDeviSlide11;
